import React, { useState } from "react";
import { MillenniumTime } from "@timeedit/millennium-time";

const MAX_HOUR = 24;
const SHORTEST_TIME_ARRAY = 2;
const MAX_MINUTE = 59;

type TTimeInputProps = {
    defaultValue: MillenniumTime;
    onUpdate: (value: MillenniumTime) => void;
};

const TimeInput = ({ defaultValue, onUpdate }: TTimeInputProps) => {
    const [value, setValue] = useState(defaultValue.format("HH:mm"));

    // Replaces componentDidUpdate(prevProps): re-sync only when the incoming value
    // changed, so a half-typed time ("14:3") is not overwritten mid-edit.
    const [prevDefault, setPrevDefault] = useState(defaultValue);
    if (defaultValue !== prevDefault) {
        setPrevDefault(defaultValue);
        const next = defaultValue.format("HH:mm");
        if (next !== value) {
            setValue(next);
        }
    }

    const onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        setValue(evt.target.value);
    };

    const returnValue = () => {
        const timeArray = value.split(":").map((str) => parseInt(str, 10));
        if (timeArray[0] > MAX_HOUR || timeArray[0] < 0 || timeArray.length < SHORTEST_TIME_ARRAY) {
            setValue(defaultValue.format("HH:mm"));
            //onUpdate(defaultValue);
            return;
        }
        if (timeArray[1]) {
            if (timeArray[1] > MAX_MINUTE || timeArray[1] < 0) {
                timeArray[1] = 0;
            }
        }
        const date = new MillenniumTime(timeArray[0], timeArray[1], 0);
        onUpdate(date);
    };

    return <input type="text" value={value} onChange={onChange} onBlur={returnValue} />;
};

export default TimeInput;
